import { Eq, eqString } from 'fp-ts/Eq';
import { Ord, ordString } from 'fp-ts/es6/Ord';
import { iso, Newtype, prism } from 'newtype-ts';
import { v4, validate } from 'uuid';

export type UUID = Newtype<{ readonly UUID: unique symbol }, string>;

export const isoUUID = iso<UUID>();

export const prismUUID = prism<UUID>(validate);

// @ts-expect-error
export function isValidUUID(x?: string | null): x is UUID {
  if (!x) {
    return false;
  }

  return validate(x);
}

export const uuid4 = v4 as unknown as () => UUID;

export const eqUUID = eqString as unknown as Eq<UUID>;

export const ordUUID = ordString as unknown as Ord<UUID>;
